import React, {cloneElement, useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {ApplicableTableSettings, infoAreaBicTable, TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../../common/AbstractListView";
import constants from '../../../../constants';
import {Search} from "../../../../filtering";
import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';
import {
  DateRenderer,
  FloatRenderer,
  TextAlignLeftRenderer,
  TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext from '../../../common/JobListViewContext';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import CurrencyLabel from '../../../../uiControls/CurrencyLabel';
import SmartTable from '../../../../uiControls/SmartTable';
import {JobNames} from "../../../../framework.core/JobNames";
import {customerPaymentMemoList} from "../../tableSettings";
import {CustomerPaymentMemoListItem} from "../../../../fms.data/models/CustomerPaymentMemoListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import PrimaryButton from "../../../../ui/PrimaryButton";
import {ActionButtonItem} from "../../../../ui/ActionButton";
import IfmsModal from "../../../../ui/IfmsModal";
import BatchStatementProcessing from "./more/BatchStatementProcessing";
import CustomerVendorDetails from '../CustomerVendorStatement';
import { Decimalformat } from '../../../common/commonExportFormat';

function CurrencyRenderer(value: number | null | undefined, currency: string, isLast: boolean = false) {
  return (
    <div style={{height: '100%'}}>
      <div style={{paddingTop: '0px', lineHeight: '12px', paddingRight: !isLast ? '15px' : '25px', textAlign: 'right'}}>
        <CurrencyLabel currency={currency} value={value}/>
      </div>
    </div>
  );
}

function AccountingEntityRenderer(onLinkToAccounting: any, {data, row, value}: any) {
  const entity = data[row.index];

  return <div style={{marginTop: '0px', marginLeft: '5px', textAlign: 'left'}}>
    <button className="e-btn e-small e-link" style={{margin: '0', padding: '0', lineHeight: '12px', color: '#0d7757'}}
            onClick={() => onLinkToAccounting(entity)}>{value}</button>
    &nbsp;
  </div>;
}

function ListCommands() {
  const appContext = useContext(ApplicationContext);
  
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);

  const selectedElement = jobListContext.selectedElement as CustomerPaymentMemoListItem;

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  function switchToInvoiceList() {
    jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/accounting?parentOp=billings', 
      'invoiceToName', 'Invoice To', selectedElement.customerName ?? '', 'u2Date', false, true);
    openNewPage(history, `/common/joblistview/invoice/accounting?parentOp=billings`, NavigationType.newPage);
  }

  function switchToCustomerPayList() {
    jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
      'customer', 'Customer', selectedElement.customerName ?? '', 'u2Date', false, true);
    openNewPage(history, `/common/joblistview/acCustomerPayment/accounting`, NavigationType.newPage);
  }

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton name='cpmemo-batch-button' size="regular" onClick={() => setSelectedPopupMenuItem({label: 'Batch Statement Processing',popupComponent: <BatchStatementProcessing jobName={JobNames.CustPaymentMemo} selectedElementId={selectedElement?.id??0} />, popupWidth: 1100 })}>Batch Statement Processing</PrimaryButton>&nbsp;
        <PrimaryButton name='cpmemo-invoice-button' size="regular" disabled={!selectedElement} onClick={switchToInvoiceList}>Invoice List</PrimaryButton>&nbsp;
        <PrimaryButton name='cpmemo-pastDue-button' size="regular" onClick={() => setSelectedPopupMenuItem({label: 'Past Due Statement',popupComponent: <CustomerVendorDetails tbId={''} customerName={''} periodType="PASTDUE" selectedElement={selectedElement} />})}>Past Due Statement</PrimaryButton>&nbsp;
        <PrimaryButton name='cpmemo-customerpay-button' size="regular" disabled={!selectedElement} onClick={switchToCustomerPayList}>Customer Pay List</PrimaryButton>
      </div>

      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
    } else if (unprocessedFkey === "F3") {
    } else if (unprocessedFkey === "F9") {
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F7") {
      jobListContext.setInfoAreaContent('custom');
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  function onLinkToAccounting(entity: any) {
    if (!entity || !entity.category || !entity.number) {
      return;
    }

    if (entity.category === 'Bill') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/bill/accounting', 'billNo', 'Bill #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/bill/accounting`, NavigationType.newPage);
    }
    if (entity.category === 'Invoice') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/accounting', 'invoiceNo', 'Invoice #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/invoice/accounting`, NavigationType.newPage);
    }
    if (entity.category === 'CrDb') {
      jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/accounting', 'crdbNo', 'CrDb #', entity.number, 'updated', false, true);
      openNewPage(history, `/common/joblistview/crdb/accounting`, NavigationType.newPage);
    }
  }

  async function loadInfoAreaInvoiceBillCrDb(id: string) {
    const apiResult = await appContext.api.getOceanImportMblInfoAreaBics(id);
    if (!apiResult) {
      return null;
    }

    const tableOptions: ApplicableTableSettings = {
      tableName: 'infoAreaBicTable',
      ...infoAreaBicTable,
      data: apiResult,
      
      rowRenderers: [
        {accessor: 'date', Cell: TextRenderer},
        {accessor: 'category', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'number', Cell: AccountingEntityRenderer.bind(this, onLinkToAccounting)},
        {accessor: 'companyName', Cell: TextAlignLeftRenderer},
        {accessor: 'cur', Cell: TextRenderer},
        // @ts-ignore:next-line
        {accessor: 'amount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.amount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'paidAmount', Cell: ({cell}) => CurrencyRenderer(cell.row.values.paidAmount, cell.row.values.cur)},
        // @ts-ignore:next-line
        {accessor: 'balance', Header: () => <div style={{marginRight: '8px'}}>Balance</div>, Cell: ({cell}) => CurrencyRenderer(cell.row.values.balance, cell.row.values.cur, true)},
      ],
    };

    return (
      <div style={{width: `${infoAreaBicTable.width}`, marginLeft: 'auto', marginRight: 'auto'}}>
        <SmartTable {...tableOptions} />
      </div>
    );
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={JobNames.CustPaymentMemo}
      //entityId={(jobListContext.selectedElement as CustomerPaymentMemoListItem | null)?.id}
      jobId={(jobListContext.selectedElement as CustomerPaymentMemoListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Customer Payment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.CustPaymentMemo,
      'CustomerPaymentMemoListItem',
      CustomerPaymentMemoListItem.calculateSearchParameters(search, CustomerPaymentMemoListItem.MapSearchFields),
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: CustomerPaymentMemoListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      {accessor: 'customerName', Cell: TextAlignLeftRenderer},
      {accessor: 'contact', Cell: TextAlignLeftRenderer},
      {accessor: 'phone', Cell: TextAlignLeftRenderer},
      {accessor: 'followUp', Cell: DateRenderer},
      {accessor: 'currency', Cell: TextRenderer},
      {accessor: 'lastPaidAmt', Cell: FloatRenderer},
      {accessor: 'checkNo', Cell: TextAlignLeftRenderer},
      {accessor: 'lastPaidDate', Cell: DateRenderer},
      {accessor: 'salesRep', Cell: TextAlignLeftRenderer},
      {accessor: 'groupId', Cell: TextRenderer},
      {accessor: 'terms', Cell: props => <FloatRenderer {...props} decimals={0} />},
      {accessor: 'avgAging', Cell: props => <FloatRenderer {...props} decimals={0} />},
      {accessor: 'currentBal', Cell: FloatRenderer},
      {accessor: 'curCnt', Cell: props => <FloatRenderer {...props} decimals={0} />},
      {accessor: 'pastDue', Cell: FloatRenderer},
      {accessor: 'pastDueCnt', Cell: props => <FloatRenderer {...props} decimals={0} />},
      {accessor: 'days15', Cell: FloatRenderer},
      {accessor: 'days30', Cell: FloatRenderer},
      {accessor: 'days45', Cell: FloatRenderer},
      {accessor: 'days60', Cell: FloatRenderer},
      {accessor: 'days90', Cell: FloatRenderer},
      {accessor: 'over90', Cell: FloatRenderer},
      {accessor: 'balance', Cell: FloatRenderer},
      {accessor: 'memo', Cell: TextAlignLeftRenderer},
    ];
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({ accessor: 'terms', changedValue: (value: any) => { return Decimalformat(value['terms'],0) } });
    colRenderer.push({ accessor: 'avgAging', changedValue: (value: any) => { return Decimalformat(value['avgAging'],0) } });
    colRenderer.push({ accessor: 'curCnt', changedValue: (value: any) => { return Decimalformat(value['curCnt'],0) } });
    colRenderer.push({ accessor: 'pastDueCnt', changedValue: (value: any) => { return Decimalformat(value['pastDueCnt'],0) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: '',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  customerPaymentMemoList;
    const cols = CustomerPaymentMemoListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderAfterConfigureButton() {
    return <></>
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: CustomerPaymentMemoListItem) {
    return row && row.id ? `/common/companies/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Customer Pay Memo';
  };
}

export default ListView;
